import { IAllLocationList, ICityList, ICountryList, IDistrictList } from 'types/LocationType'
import http from '../core/http-common'
import { OccupancyFilterRequest } from '../types/FloorType'

class LocationService {
  GetLocationOccupancy(request: OccupancyFilterRequest) {
    return http.post<any>('/Location/GetLocationOccupancy', request)
  }

  GetAllLocationList() {
    return http.get<IAllLocationList[]>(`/Location/GetAllAuthLocationList`)
  }

  GetAllLocationByFirmAndType(request: any) {
    return http.post<any>(`/Location/GetAllLocationListByFirmAndType`, request)
  }

  FindLocation(keyword: string) {
    return http.get<IAllLocationList[]>(`/Location/FindAuthLocationList?keyword=${keyword}`)
  }

  /* Country - City - District */
  getCountryList() {
    return http.get<ICountryList[]>('/Country/GetAuthCountryList')
  }
  getCityList(countryId: number) {
    return http.get<ICityList[]>(`/City/GetAuthCityList?countryId=${countryId}`)
  }
  getDistrictList(cityId: number) {
    return http.get<IDistrictList[]>(`/District/GetAuthDistrictList?cityId=${cityId}`)
  }
}

export default new LocationService()
